/**
 * What this web build is (plan.md step 54): the platform version, the commit
 * and the time it was built — compiled in by `buildInfoPlugin`, so the version
 * matrix can say it with no network at all.
 *
 * **Guarded, on purpose.** A Vite dev server started before the plugin existed
 * never defines `__BUILD__`, and an unguarded read threw at import and blanked
 * every page (2026-10-06). "unknown" is the honest answer there; a real build
 * always has the define (`lib/build.test.ts`, and the build's own output).
 */
declare const __BUILD__: { version: string; sha: string; builtAt: string } | undefined;

export const BUILD: Readonly<{ version: string; sha: string; builtAt: string }> =
  typeof __BUILD__ === 'undefined' ? { version: 'unknown', sha: 'unknown', builtAt: '' } : __BUILD__;
